/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Audio_Description_Export_Preset_LoadedInputs */



/**
* | output |
* | --- |
* | "Preset \"{name}\" loaded" |
*
* @param {Audio_Description_Export_Preset_LoadedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_loaded = /** @type {((inputs: Audio_Description_Export_Preset_LoadedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_LoadedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Préréglage "${i?.name}" chargé`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Voreinstellung "${i?.name}" geladen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Preimpostazione "${i?.name}" caricata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Загружен пресет "${i?.name}".`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Preajuste "${i?.name}" cargado`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`预设“${i?.name}”已加载`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`プリセット「${i?.name}」がロードされました`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`प्रीसेट "${i?.name}" लोड हो गया`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Predefinição "${i?.name}" carregada`)
	return /** @type {LocalizedString} */ (`Preset "${i?.name}" loaded`)
});